import React, { Component, useEffect } from 'react';
import 'react-step-progress-bar/styles.css';
import { FullWidthContainer } from '../FullWidthContainer';
import { ImageLazyLoad } from '../ImageLazyLoad';
import { ProgressBar } from 'react-step-progress-bar';
import styled from 'styled-components';
import { PrimaryButton, BasicButton } from '../Buttons';
import arrowLeft from '../../assets/images/arrow_left.png';
import arrowRight from '../../assets/images/arrow_right.png';
import ScrollMagic from 'scrollmagic';

const BannerImage = styled.div`
  width: 100%;
  height: 80vh !important;
  object-fit: cover;
  transition: 0.7s;
  object-position: center;
  opacity: 1;

  @media only screen and (max-width: 768px) {
    height: 50vh !important;
  }
  .gatsby-image-wrapper {
    position: static !important;
  }
  .imgTransition {
    transition: all 0.5s ease-in;
    opacity: 1;
  }
  .hideImage {
    opacity: 0.8;
    position: absolute;
  }
`;

const Heading = styled.h1`
  color: white;
  /* text-shadow: 2px 2px 5px rgba(0, 0, 0, 0.56); */
  font-weight: bold;
  text-align: left;
  z-index: 2;
  font-size: 4em;
  @media only screen and (max-width: 768px) {
    text-align: center;
  }
  @media only screen and (max-width: 576px) {
    font-size: 2em;
  }
`;

const HeadingDiv = styled.div`
  position: absolute;
  top: 10%;
  left: 6%;
  right: 50%;
  z-index: 9;
  height: max-content;

  @media only screen and (max-width: 768px) {
    top: 30%;
    left: 5%;
    right: 5%;
    bottom: 20%;
  }
`;
const BottomNavBar = styled.div`
  position: absolute;
  bottom: 1%;
  left: 5%;
  right: 5%;
  padding: 1%;
  display: flex;
  align-items: center;
`;
const Count = styled.span`
  color: white;
  padding: 1%;
  font-weight: bolder;
`;
const ProgressBarStyled = styled.div`
  flex-grow: 2;
  padding: 1%;
`;

const Arrow = styled.span`
  color: whitesmoke;
  display: flex;
  justify-content: space-around;
  width: 70px;
`;

const ArrowImage = styled.img`
  padding: 0 2px;
  width: 24px !important;
  height: 24px !important;
  filter: brightness(0) invert(1);
`;

const ArrowContainer = styled.div`
  &:active {
    transform: translate3d(0, 0, 0);
    backface-visibility: hidden;
    color: red;
  }
`;

const SubText = styled.p`
  color: white;
  /* text-shadow: 2px 2px 5px rgba(0, 0, 0, 0.56); */
  /* position: absolute;
  top: 30%;
  left: 6%; */
  font-size: 1.7em;
  text-align: left;
  z-index: 2;
  opacity: 1;
  font-family: AvenirMedium;
  line-height: 2.4rem;
  @media only screen and (max-width: 768px) {
    /* top: 60%;
    left: 5%;
    right: 5%;
    bottom: 20%; */
    text-align: center;
    font-size: 1.3em;
  }
`;

const ButtonDiv = styled.div`
  @media only screen and (max-width: 576px) {
    width: max-content;
    margin: auto;
    outline: none;
    a {
      text-decoration: none;
    }
  }
  :hover {
    cursor: pointer;
  }
`;

class Slider extends Component {
  constructor(props) {
    super(props);
    this.state = { index: 0, count: 0, sliderEntered: false };
  }

  componentDidMount() {
    this.setState({
      count: this.props.data.length
    });

    const controller = new ScrollMagic.Controller();

    new ScrollMagic.Scene({
      triggerElement: '.abtSlider',
      reverse: true,
      triggerHook: 0.2,
      loglevel: 2,
      duration: '100%'
    })
      .on('enter', () => {
        if (!this.state.sliderEntered) {
          setInterval(() => {
            const { index, count } = this.state;
            this.setState({
              index: index < count - 1 ? index + 1 : 0,
              progressPercent: 0
            });
          }, 3000);
          this.setState({ sliderEntered: true });
        }
      })
      .addTo(controller);
  }

  handlePrevious = () => {
    var { count, index: currentIndex } = this.state;
    if (currentIndex > 0) {
      currentIndex = currentIndex - 1;
    } else {
      currentIndex = count - 1;
    }
    this.setState({ index: currentIndex });
  };

  handleNext = () => {
    var { count, index: currentIndex } = this.state;
    if (currentIndex !== count - 1) {
      currentIndex = currentIndex + 1;
    } else {
      currentIndex = 0;
    }
    this.setState({ index: currentIndex });
  };
  render() {
    var { count, index } = this.state;
    let current = this.props.data[index];
    var showOrHideImage = 'hideImage';
    return (
      <FullWidthContainer>
        <HeadingDiv className='abtSlider'>
          <Heading>{current.text}</Heading>
          <SubText
            dangerouslySetInnerHTML={{
              __html: current.subText ? current.subText : ''
            }}
          />
          {current.buttonText && current.to && (
            <ButtonDiv>
              <a href={current.to} target='_blank'>
                <BasicButton
                  text={current.buttonText}
                  invert
                  textColor={'#fff'}
                />
              </a>
            </ButtonDiv>
          )}
        </HeadingDiv>
        <BannerImage>
          {this.props.data.map((item, tempIndex) => {
            return (
              <div
                key={tempIndex}
                className={
                  'imgTransition ' +
                  (index === tempIndex ? '' : showOrHideImage)
                }>
                <ImageLazyLoad src={item.url} />
              </div>
            );
          })}
        </BannerImage>

        <BottomNavBar>
          <Count>
            {index + 1} / {count}
          </Count>
          <ProgressBarStyled>
            <ProgressBar
              percent={((index + 1) * 100) / count}
              height='5px'
              stepPositions={25}
              filledBackground='linear-gradient(to right, #fefb72, #f0bb31)'
            />
          </ProgressBarStyled>
          <Arrow>
            <ArrowContainer onClick={this.handlePrevious}>
              <ArrowImage src={arrowLeft} />
            </ArrowContainer>
            <ArrowContainer onClick={this.handleNext}>
              <ArrowImage src={arrowRight} />
            </ArrowContainer>
          </Arrow>
        </BottomNavBar>
      </FullWidthContainer>
    );
  }
}
export { Slider };
